import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'

// Pages
import Login from './pages/Login'
import Register from './pages/Register2026'
import Dashboard from './pages/Dashboard'
import InvoicePage from './pages/InvoicePage'
import QuotationPage from './pages/QuotationPage'
import ClientsPage from './pages/ClientsPage'
import ItemsPage from './pages/ItemsPage'
import SettingsPage from './pages/SettingsPage'
import BackupSettings from './pages/BackupSettings'
import DevTools from './pages/DevTools'

// Layout
import AppShell from './app/AppShell'

// Protected Route wrapper
function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth()
  
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="text-slate-600">Loading...</div>
      </div>
    )
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  
  return children
}

// Public Route wrapper (redirect to dashboard if already authenticated)
function PublicRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth()
  
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="text-slate-600">Loading...</div>
      </div>
    )
  }
  
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }
  
  return children
}

export function AppRouter() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      } />
      
      <Route path="/register" element={
        <PublicRoute>
          <Register />
        </PublicRoute>
      } />
      
      {/* Protected routes */}
      <Route path="/" element={
        <ProtectedRoute>
          <AppShell />
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="invoices" element={<InvoicePage />} />
        <Route path="quotations" element={<QuotationPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="items" element={<ItemsPage />} />
        <Route path="products" element={<ItemsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="settings-backup" element={<BackupSettings />} />
        <Route path="devtools" element={<DevTools />} />
      </Route>
      
      {/* Catch all - redirect to dashboard if authenticated, login otherwise */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
